'use client';

import { Button as ChakraButton } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

export const Button = ({ children, ...other }: ButtonProps) => {
	const { formState: { isLoading, isSubmitting } } = useFormContext();
	const isDisabled = isSubmitting || isLoading;

	return (
		<ChakraButton {...other} disabled={isDisabled} type="button">
			{children}
		</ChakraButton>
	);
};
